import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { appendFormValues } from "./requestPayload";

const API_URL = config.API_URL;

const webhookStatus = () => axios.get(API_URL + "afterlogin/stripe/webhook-status", { headers: authHeader() });

const createWebhook = () => axios.post(
  API_URL + "webhook/create", { webhook_topic: "stripewebhooks" }, { headers: authHeader() },
);

const updateWebhook = (endpointId) => axios.post(
  API_URL + "webhook/update",
  { webhook_topic: "stripewebhooks", webhook_id: endpointId },
  { headers: authHeader() },
);

const create = (values) => {
  const formData = appendFormValues(new FormData(), values);
  const action = "afterlogin/stripe/stripeStore";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const updatekeys = (values) => {
  const formData = appendFormValues(new FormData(), values);
  const action = "afterlogin/stripe/stripeupdatekeys";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const setup = (values) => {
  const formData = appendFormValues(new FormData(), values);
  const action = "afterlogin/stripe/setup";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const oauth = (values) => {
  const formData = appendFormValues(new FormData(), values);
  const action = "afterlogin/stripe/oauth";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const cardpayment = (values) => {
  const formData = appendFormValues(new FormData(), values);
  // The Flask backend retired the legacy raw-card store route; stripeStore is
  // the compatibility boundary for the former server-side raw-card step.
  const action = "afterlogin/stripe/stripeStore";
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const stripepayment = (values) => {
  const formData = new FormData();
  for (let value in values || {}) {
    if (["auth_key", "action"].includes(value)) continue;
    if (["paymentIntent", "setupIntent"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = `afterlogin/stripe/stripepayment`;
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const stripepaymentfailed = (values) => {
  const formData = new FormData();
  for (let value in values || {}) {
    if (["auth_key", "action"].includes(value)) continue;
    if (["error"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = `afterlogin/stripe/stripepaymentfailed`;
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};

const stripeApiController = {
  webhookStatus,
  createWebhook,
  updateWebhook,
  create,
  setup,
  cardpayment,
  oauth,
  updatekeys,
  stripepayment,
  stripepaymentfailed,
};
export default stripeApiController;
